(function () {
  const root = document.documentElement;
  const toggle = document.getElementById('themeToggle');
  const logos = Array.from(document.querySelectorAll('.logo-cluster'));
  if (!toggle) return;

  const merchantMode =
    typeof window.__SHOPIFY_APPEARANCE_MODE__ === 'string'
      ? window.__SHOPIFY_APPEARANCE_MODE__
      : 'dark';

  function resolveMerchantTheme() {
    if (merchantMode === 'auto') {
      return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
    }
    return merchantMode === 'light' ? 'light' : 'dark';
  }

  const storedTheme = localStorage.getItem('cluster-theme');
  const initialTheme = storedTheme || resolveMerchantTheme();

  function applyTheme(theme) {
    root.setAttribute('data-theme', theme);
    toggle.textContent = theme === 'dark' ? 'Light' : 'Dark';
    toggle.setAttribute('aria-label', theme === 'dark' ? 'Activar modo claro' : 'Activar modo oscuro');
    logos.forEach((logo) => {
      const blackLogo = logo.dataset.logoBlack;
      const whiteLogo = logo.dataset.logoWhite;
      if (!blackLogo || !whiteLogo) return;
      logo.src = theme === 'dark' ? whiteLogo : blackLogo;
    });
  }

  applyTheme(initialTheme);

  toggle.addEventListener('click', function () {
    const nextTheme = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    applyTheme(nextTheme);
    localStorage.setItem('cluster-theme', nextTheme);
  });
})();

(function () {
  const sliders = document.querySelectorAll('[data-cluster-case-slider]');
  sliders.forEach((root) => {
    const slides = Array.from(root.querySelectorAll('.case-slide'));
    const dots = Array.from(root.querySelectorAll('.case-dot'));
    const prevButtons = Array.from(root.querySelectorAll('[data-case-prev]'));
    const nextButtons = Array.from(root.querySelectorAll('[data-case-next]'));
    if (!slides.length) return;

    let current = 0;

    function render(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    }

    prevButtons.forEach((button) => button.addEventListener('click', () => render(current - 1)));
    nextButtons.forEach((button) => button.addEventListener('click', () => render(current + 1)));
    dots.forEach((dot, i) => dot.addEventListener('click', () => render(i)));
  });
})();

(function () {
  const sections = document.querySelectorAll('[data-cluster-cost-calculator]');
  if (!sections.length) return;

  const currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });

  const groupedNumber = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
  });

  function parseNum(value) {
    const n = Number.parseFloat(String(value).replace(/,/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  function formatGroupedNumber(value) {
    const n = Math.round(parseNum(value));
    if (n <= 0) return '';
    return groupedNumber.format(n);
  }

  function bindGroupedInput(input) {
    input.addEventListener('focus', () => {
      const n = parseNum(input.value);
      input.value = n > 0 ? String(n) : '';
    });

    input.addEventListener('blur', () => {
      input.value = formatGroupedNumber(input.value);
    });

    input.addEventListener('input', () => {
      input.value = input.value.replace(/[^\d,]/g, '');
    });
  }

  function readInput(root, selector) {
    const el = root.querySelector(selector);
    return el ? parseNum(el.value) : 0;
  }

  function formatAmount(value) {
    return currency.format(Math.round(value));
  }

  function formatCostCell(value) {
    return currency.format(Math.round(Math.max(0, value)));
  }

  function formatSavingsDisplay(savings) {
    const abs = Math.abs(Math.round(savings));
    const formatted = currency.format(abs);
    if (savings > 0) {
      return `-${formatted}`;
    }
    if (savings < 0) {
      return `+${formatted}`;
    }
    return currency.format(0);
  }

  function setShopifyStaticValues(root) {
    const voucherEl = root.querySelector(
      '[data-cost-calc-card="shopify"] [data-cost-calc-row="voucher"] [data-cost-calc-shopify-value="voucher"]'
    );

    if (voucherEl) voucherEl.textContent = formatCostCell(0);
  }

  function setCostCell(costRoot, annual, monthly) {
    if (!costRoot) return;

    const annualEl = costRoot.querySelector('[data-cost-calc-cost-annual]');
    const monthlyEl = costRoot.querySelector('[data-cost-calc-cost-monthly]');

    if (annualEl) annualEl.textContent = formatCostCell(annual);
    if (monthlyEl) monthlyEl.textContent = formatCostCell(monthly);

    costRoot.classList.toggle('cost-calc-card__cost--zero', annual <= 0 && monthly <= 0);
    costRoot.removeAttribute('aria-hidden');
  }

  function setPlanRowCost(card, rowKey, annual, monthly) {
    const row = card.querySelector(`[data-cost-calc-plan-row="${rowKey}"]`);
    setCostCell(row?.querySelector('[data-cost-calc-plan-cost]'), annual, monthly);
  }

  function setPlanTotal(card, monthly, annual) {
    const monthlyEl = card.querySelector('[data-cost-calc-plan-total-monthly]');
    const annualEl = card.querySelector('[data-cost-calc-plan-total-annual]');

    if (monthlyEl) monthlyEl.textContent = `${formatCostCell(monthly)}/mes`;
    if (annualEl) annualEl.textContent = `${formatCostCell(annual)}/año`;
  }

  function setVtexTotal(root, monthly, annual) {
    const monthlyEl = root.querySelector('[data-cost-calc-vtex-total-monthly]');
    const annualEl = root.querySelector('[data-cost-calc-vtex-total-annual]');

    if (monthlyEl) monthlyEl.textContent = `${formatCostCell(monthly)}/mes`;
    if (annualEl) annualEl.textContent = `${formatCostCell(annual)}/año`;
  }

  function formatPlanResultName(planName, brandPrefix) {
    const prefix = String(brandPrefix || 'Shopify').trim();
    const name = String(planName || 'Plan').trim();
    if (!prefix) return name;
    if (name.toLowerCase().startsWith(prefix.toLowerCase())) return name;
    return `${prefix} ${name}`;
  }

  function readPlanRates(card) {
    const thirdPartyPercent =
      card.dataset.planThirdPartyPercent ?? card.dataset.planCardPercent ?? '0';

    return {
      monthlyFixed: parseNum(card.dataset.planMonthlyFixed),
      thirdPartyPercent: parseNum(thirdPartyPercent) / 100,
      cardPercent: parseNum(thirdPartyPercent) / 100,
      cardFixed: parseNum(card.dataset.planCardFixed),
      useGmvFee: card.dataset.planUseGmvFee === 'true',
      gmvPercent: parseNum(card.dataset.planGmvPercent) / 100,
    };
  }

  function estimateOrderCount(monthlySales, aov) {
    if (aov <= 0) return monthlySales > 0 ? 1 : 0;
    return Math.max(monthlySales > 0 ? 1 : 0, Math.round(monthlySales / aov));
  }

  function buildPlanCosts(monthlySales, aov, rates, feeModel, sectionTxnPercent = 0) {
    let fixedMonthly = rates.monthlyFixed;
    let variableMonthly;

    if (feeModel === 'payments') {
      if (rates.useGmvFee) {
        fixedMonthly = Math.max(rates.monthlyFixed, monthlySales * rates.gmvPercent);
        const txnRate = rates.thirdPartyPercent > 0 ? rates.thirdPartyPercent : sectionTxnPercent;
        variableMonthly = monthlySales * txnRate;
      } else {
        fixedMonthly = rates.monthlyFixed;
        variableMonthly = monthlySales * rates.thirdPartyPercent;
      }
    } else if (feeModel === 'third-party') {
      if (rates.useGmvFee) {
        fixedMonthly = Math.max(rates.monthlyFixed, monthlySales * rates.gmvPercent);
      }

      variableMonthly = monthlySales * rates.thirdPartyPercent;
    } else {
      const orders = estimateOrderCount(monthlySales, aov);
      variableMonthly = monthlySales * rates.cardPercent + orders * rates.cardFixed;
    }

    const totalMonthly = fixedMonthly + variableMonthly;

    return {
      fixedMonthly,
      fixedAnnual: fixedMonthly * 12,
      variableMonthly,
      variableAnnual: variableMonthly * 12,
      totalMonthly,
      totalAnnual: totalMonthly * 12,
    };
  }

  function setVtexRowCosts(root, key, vtexAnnual, vtexMonthly) {
    const vtexRow = root.querySelector(`[data-cost-calc-card="vtex"] [data-cost-calc-row="${key}"]`);
    setCostCell(vtexRow?.querySelector('[data-cost-calc-vtex-cost]'), vtexAnnual, vtexMonthly);
  }

  function buildVtexTotals(root, monthlySales) {
    const annualSales = monthlySales * 12;
    const voucher = readInput(root, '[data-cost-calc-voucher]');
    const monthlyFixed = readInput(root, '[data-cost-calc-monthly-fixed]');
    const feeB2c = readInput(root, '[data-cost-calc-fee-b2c]') / 100;
    const vtexVariableMonthly = monthlySales * feeB2c;

    const lines = {
      fixed: { vtexAnnual: monthlyFixed * 12, vtexMonthly: monthlyFixed },
      variable: { vtexAnnual: annualSales * feeB2c, vtexMonthly: vtexVariableMonthly },
      voucher: { vtexAnnual: voucher, vtexMonthly: voucher / 12 },
    };

    let vtexTotal = 0;

    for (const key of Object.keys(lines)) {
      const line = lines[key];
      setVtexRowCosts(root, key, line.vtexAnnual, line.vtexMonthly);
      vtexTotal += line.vtexAnnual;
    }

    return { annualSales, monthlySales, vtexTotal };
  }

  function initVtexPlansCalculator(root) {
    const feeModel = root.dataset.costCalcFeeModel || 'payments';
    const sectionTxnPercent = (parseNum(root.dataset.shopifyTransactionPercent) || 0.25) / 100;
    const form = root.querySelector('.cost-calc-form');
    const compare = root.querySelector('[data-cost-calc-compare]');
    const result = root.querySelector('[data-cost-calc-result]');
    const savingsEl = root.querySelector('[data-cost-calc-savings]');
    const noteEl = root.querySelector('[data-cost-calc-result-note]');
    const resultHeading = root.querySelector('.cost-calc-result__heading');
    const salesInput = root.querySelector('[data-cost-calc-monthly-sales]');
    const planCards = [...root.querySelectorAll('[data-cost-calc-plan-card]')];

    if (!form || !result || !compare || !planCards.length) return;

    let hasCalculated = false;

    root.querySelectorAll('[data-cost-calc-grouped-input]').forEach((input) => {
      bindGroupedInput(input);
      const initial = parseNum(input.value);
      if (initial > 0) {
        input.value = formatGroupedNumber(initial);
      }
    });

    function renderVtexPlansResult(vtexData, best, runnerUp) {
      const brandPrefix = root.dataset.resultBrandPrefix || 'Shopify';
      const bestPlanLabel = formatPlanResultName(best.planName, brandPrefix);

      setVtexTotal(root, vtexData.vtexTotal / 12, vtexData.vtexTotal);

      const savings = vtexData.vtexTotal - best.costs.totalAnnual;
      const annualLabel = formatAmount(vtexData.annualSales);

      savingsEl.textContent = formatSavingsDisplay(savings);
      result.classList.toggle('cost-calc-result--favorable', savings > 0);
      result.classList.toggle('cost-calc-result--unfavorable', savings < 0);

      if (savings > 0) {
        noteEl.textContent = `Con ventas mensuales de ${formatAmount(vtexData.monthlySales)} (${annualLabel}/año), ${bestPlanLabel} ofrece el menor costo Shopify (~${formatCostCell(best.costs.totalMonthly)}/mes). Ahorro estimado vs VTEX: ${formatCostCell(savings / 12)}/mes.`;
      } else if (savings < 0) {
        noteEl.textContent = `Con ventas mensuales de ${formatAmount(vtexData.monthlySales)} (${annualLabel}/año), ${bestPlanLabel} sería ~${formatCostCell(Math.abs(savings) / 12)}/mes más costoso que VTEX con estas tarifas.`;
      } else {
        noteEl.textContent = `Con ventas mensuales de ${formatAmount(vtexData.monthlySales)} (${annualLabel}/año), ${bestPlanLabel} tiene un costo equivalente a VTEX con estas tarifas.`;
      }

      if (runnerUp && savings > 0) {
        const runnerLabel = formatPlanResultName(runnerUp.planName, brandPrefix);
        const deltaMonthly = runnerUp.costs.totalMonthly - best.costs.totalMonthly;
        noteEl.textContent += ` También ahorra ${formatCostCell(deltaMonthly)}/mes frente a ${runnerLabel}.`;
      }

      result.hidden = false;
    }

    function calculate({ focusResult = false, formatSalesOnSuccess = false } = {}) {
      const monthlySales = readInput(root, '[data-cost-calc-monthly-sales]');

      if (monthlySales <= 0) {
        if (salesInput) {
          salesInput.setAttribute('aria-invalid', 'true');
          if (!hasCalculated) salesInput.focus();
        }
        return false;
      }

      if (salesInput) {
        salesInput.setAttribute('aria-invalid', 'false');
        if (formatSalesOnSuccess) {
          salesInput.value = formatGroupedNumber(monthlySales);
        }
      }

      const vtexData = buildVtexTotals(root, monthlySales);

      const planSummaries = planCards.map((card) => {
        const rates = readPlanRates(card);
        const costs = buildPlanCosts(monthlySales, 100, rates, feeModel, sectionTxnPercent);
        const planName = card.querySelector('.cost-calc-card__title')?.textContent?.trim() || 'Plan';

        setPlanRowCost(card, 'fixed', costs.fixedAnnual, costs.fixedMonthly);
        setPlanRowCost(card, 'variable', costs.variableAnnual, costs.variableMonthly);
        setPlanTotal(card, costs.totalMonthly, costs.totalAnnual);

        return { card, planName, costs };
      });

      planSummaries.sort((a, b) => a.costs.totalMonthly - b.costs.totalMonthly);
      const best = planSummaries[0];
      const runnerUp = planSummaries[1];

      planCards.forEach((card) => {
        card.classList.remove('cost-calc-card--plan-best');
        card.removeAttribute('aria-describedby');

        const badge = card.querySelector('[data-cost-calc-plan-badge]');
        if (badge) badge.hidden = true;
      });

      if (best?.card) {
        best.card.classList.add('cost-calc-card--plan-best');

        const badge = best.card.querySelector('[data-cost-calc-plan-badge]');
        if (badge) {
          badge.hidden = false;
          best.card.setAttribute('aria-describedby', badge.id);
        }
      }

      renderVtexPlansResult(vtexData, best, runnerUp);

      const firstReveal = compare.hidden;
      compare.hidden = false;
      hasCalculated = true;

      if (firstReveal && focusResult) {
        requestAnimationFrame(() => {
          if (resultHeading) {
            resultHeading.focus();
            resultHeading.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }

      return true;
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      calculate({ focusResult: true, formatSalesOnSuccess: true });
    });

    root
      .querySelectorAll(
        '[data-cost-calc-monthly-sales], [data-cost-calc-monthly-fixed], [data-cost-calc-fee-b2c], [data-cost-calc-voucher]'
      )
      .forEach((input) => {
        input.addEventListener('input', () => {
          if (!hasCalculated) return;
          calculate();
        });
      });
  }

  function initShopifyPlansCalculator(root) {
    const feeModel = root.dataset.costCalcFeeModel || 'third-party';
    const form = root.querySelector('.cost-calc-form');
    const compare = root.querySelector('[data-cost-calc-compare]');
    const result = root.querySelector('[data-cost-calc-result]');
    const savingsEl = root.querySelector('[data-cost-calc-savings]');
    const noteEl = root.querySelector('[data-cost-calc-result-note]');
    const resultHeading = root.querySelector('.cost-calc-result__heading');
    const salesInput = root.querySelector('[data-cost-calc-monthly-sales]');
    const aovInput = root.querySelector('[data-cost-calc-aov]');
    const planCards = [...root.querySelectorAll('[data-cost-calc-plan-card]')];

    if (!form || !result || !compare) return;

    if (!planCards.length) {
      const emptyMessage = root.querySelector('[data-cost-calc-plans-empty]');
      if (emptyMessage) emptyMessage.hidden = false;
      return;
    }

    let hasCalculated = false;

    root.querySelectorAll('[data-cost-calc-grouped-input]').forEach((input) => {
      bindGroupedInput(input);
      const initial = parseNum(input.value);
      if (initial > 0) {
        input.value = formatGroupedNumber(initial);
      }
    });

    function renderPlansResult(summary) {
      const brandPrefix = root.dataset.resultBrandPrefix || 'Shopify';
      const planLabel = formatPlanResultName(summary.best.planName, brandPrefix);

      if (resultHeading) resultHeading.textContent = planLabel;
      savingsEl.textContent = formatCostCell(summary.best.costs.totalMonthly);
      noteEl.textContent = summary.note;
      result.hidden = false;
    }

    function calculate({ focusResult = false, formatSalesOnSuccess = false } = {}) {
      const monthlySales = readInput(root, '[data-cost-calc-monthly-sales]');
      const aov = aovInput
        ? readInput(root, '[data-cost-calc-aov]') || parseNum(root.dataset.defaultAov) || 100
        : 100;

      if (monthlySales <= 0) {
        if (salesInput) {
          salesInput.setAttribute('aria-invalid', 'true');
          if (!hasCalculated) salesInput.focus();
        }
        return false;
      }

      if (salesInput) {
        salesInput.setAttribute('aria-invalid', 'false');
        if (formatSalesOnSuccess) {
          salesInput.value = formatGroupedNumber(monthlySales);
        }
      }

      if (aovInput && feeModel !== 'third-party') {
        aovInput.setAttribute('aria-invalid', aov <= 0 ? 'true' : 'false');
        if (aov <= 0) return false;
        if (formatSalesOnSuccess) {
          aovInput.value = formatGroupedNumber(aov);
        }
      }

      const planSummaries = planCards.map((card) => {
        const rates = readPlanRates(card);
        const costs = buildPlanCosts(monthlySales, aov, rates, feeModel);
        const planName = card.querySelector('.cost-calc-card__title')?.textContent?.trim() || 'Plan';

        setPlanRowCost(card, 'fixed', costs.fixedAnnual, costs.fixedMonthly);
        setPlanRowCost(card, 'variable', costs.variableAnnual, costs.variableMonthly);
        setPlanTotal(card, costs.totalMonthly, costs.totalAnnual);

        return { card, planName, costs };
      });

      planSummaries.sort((a, b) => a.costs.totalMonthly - b.costs.totalMonthly);
      const best = planSummaries[0];
      const runnerUp = planSummaries[1];
      const savingsVsNextMonthly = runnerUp
        ? runnerUp.costs.totalMonthly - best.costs.totalMonthly
        : 0;
      const bestPlanLabel = formatPlanResultName(
        best.planName,
        root.dataset.resultBrandPrefix || 'Shopify'
      );

      planCards.forEach((card) => {
        card.classList.remove('cost-calc-card--plan-best');
        card.removeAttribute('aria-describedby');

        const badge = card.querySelector('[data-cost-calc-plan-badge]');
        if (badge) badge.hidden = true;
      });

      if (best?.card) {
        best.card.classList.add('cost-calc-card--plan-best');

        const badge = best.card.querySelector('[data-cost-calc-plan-badge]');
        if (badge) {
          badge.hidden = false;
          best.card.setAttribute('aria-describedby', badge.id);
        }
      }

      renderPlansResult({
        best,
        note: runnerUp
          ? `Con ventas de ${formatAmount(monthlySales)}/mes, ${bestPlanLabel} tiene el menor costo Shopify (~${formatCostCell(best.costs.totalMonthly)}/mes). Ahorro estimado vs ${formatPlanResultName(runnerUp.planName, root.dataset.resultBrandPrefix || 'Shopify')}: ${formatCostCell(savingsVsNextMonthly)}/mes. No incluye comisiones de tu pasarela de pagos.`
          : `Con ventas de ${formatAmount(monthlySales)}/mes, el costo Shopify estimado con ${bestPlanLabel} es ${formatCostCell(best.costs.totalMonthly)}/mes (${formatCostCell(best.costs.totalAnnual)}/año). No incluye comisiones de tu pasarela de pagos.`,
      });

      const firstReveal = compare.hidden;
      compare.hidden = false;
      hasCalculated = true;

      const emptyMessage = root.querySelector('[data-cost-calc-plans-empty]');
      if (emptyMessage) emptyMessage.hidden = true;

      if (firstReveal && focusResult) {
        requestAnimationFrame(() => {
          if (resultHeading) {
            resultHeading.focus();
            resultHeading.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }

      return true;
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      calculate({ focusResult: true, formatSalesOnSuccess: true });
    });

    const liveInputSelector =
      feeModel === 'third-party'
        ? '[data-cost-calc-monthly-sales]'
        : '[data-cost-calc-monthly-sales], [data-cost-calc-aov]';
    root.querySelectorAll(liveInputSelector).forEach((input) => {
      input.addEventListener('input', () => {
        if (!hasCalculated) return;
        calculate();
      });
    });
  }

  function setRowCosts(root, key, vtexAnnual, shopifyAnnual, vtexMonthly, shopifyMonthly) {
    const vtexRow = root.querySelector(`[data-cost-calc-card="vtex"] [data-cost-calc-row="${key}"]`);
    const shopifyRow = root.querySelector(`[data-cost-calc-card="shopify"] [data-cost-calc-row="${key}"]`);

    setCostCell(vtexRow?.querySelector('[data-cost-calc-vtex-cost]'), vtexAnnual, vtexMonthly);
    setCostCell(shopifyRow?.querySelector('[data-cost-calc-shopify-cost]'), shopifyAnnual, shopifyMonthly);
  }

  function setShopifyRowCosts(root, key, shopifyAnnual, shopifyMonthly) {
    const shopifyRow = root.querySelector(`[data-cost-calc-card="shopify"] [data-cost-calc-row="${key}"]`);
    setCostCell(shopifyRow?.querySelector('[data-cost-calc-shopify-cost]'), shopifyAnnual, shopifyMonthly);
  }

  function readShopifyRates(root) {
    return {
      monthlyMin: parseNum(root.dataset.shopifyMonthlyMin) || 2300,
      gmvPercent: (parseNum(root.dataset.shopifyGmvPercent) || 0.35) / 100,
      txnPercent: (parseNum(root.dataset.shopifyTransactionPercent) || 0.25) / 100,
    };
  }

  function buildShopifyLines(monthlySales, rates) {
    const monthlyGmvFee = monthlySales * rates.gmvPercent;
    const shopifyFixedMonthly = Math.max(rates.monthlyMin, monthlyGmvFee);
    const shopifyTransactionMonthly = monthlySales * rates.txnPercent;

    return {
      fixed: {
        shopifyAnnual: shopifyFixedMonthly * 12,
        shopifyMonthly: shopifyFixedMonthly,
      },
      variable: {
        shopifyAnnual: shopifyTransactionMonthly * 12,
        shopifyMonthly: shopifyTransactionMonthly,
      },
    };
  }

  function buildShopifyOnly(root, monthlySales) {
    const annualSales = monthlySales * 12;
    const rates = readShopifyRates(root);
    const lines = buildShopifyLines(monthlySales, rates);
    let shopifyTotal = 0;

    for (const key of Object.keys(lines)) {
      const line = lines[key];
      setShopifyRowCosts(root, key, line.shopifyAnnual, line.shopifyMonthly);
      shopifyTotal += line.shopifyAnnual;
    }

    setShopifyStaticValues(root);

    return {
      annualSales,
      monthlySales,
      shopifyTotal,
      shopifyMonthlyTotal: shopifyTotal / 12,
    };
  }

  function buildComparison(root, monthlySales) {
    const annualSales = monthlySales * 12;
    const rates = readShopifyRates(root);

    const voucher = readInput(root, '[data-cost-calc-voucher]');
    const monthlyFixed = readInput(root, '[data-cost-calc-monthly-fixed]');
    const feeB2c = readInput(root, '[data-cost-calc-fee-b2c]') / 100;

    const shopifyLines = buildShopifyLines(monthlySales, rates);
    const vtexVariableMonthly = monthlySales * feeB2c;

    const lines = {
      fixed: {
        vtexAnnual: monthlyFixed * 12,
        shopifyAnnual: shopifyLines.fixed.shopifyAnnual,
        vtexMonthly: monthlyFixed,
        shopifyMonthly: shopifyLines.fixed.shopifyMonthly,
      },
      variable: {
        vtexAnnual: annualSales * feeB2c,
        shopifyAnnual: shopifyLines.variable.shopifyAnnual,
        vtexMonthly: vtexVariableMonthly,
        shopifyMonthly: shopifyLines.variable.shopifyMonthly,
      },
      voucher: {
        vtexAnnual: voucher,
        shopifyAnnual: 0,
        vtexMonthly: voucher / 12,
        shopifyMonthly: 0,
      },
    };

    let vtexTotal = 0;
    let shopifyTotal = 0;

    for (const key of Object.keys(lines)) {
      const line = lines[key];
      setRowCosts(root, key, line.vtexAnnual, line.shopifyAnnual, line.vtexMonthly, line.shopifyMonthly);
      vtexTotal += line.vtexAnnual;
      shopifyTotal += line.shopifyAnnual;
    }

    setShopifyStaticValues(root);

    return {
      annualSales,
      monthlySales,
      vtexTotal,
      shopifyTotal,
      savings: vtexTotal - shopifyTotal,
    };
  }

  sections.forEach((root) => {
    const mode = root.dataset.costCalcMode || 'compare';

    if (mode === 'shopify-plans') {
      initShopifyPlansCalculator(root);
      return;
    }

    const hasVtexPlans =
      root.querySelector('[data-cost-calc-card="vtex"]') &&
      root.querySelector('[data-cost-calc-plan-card]');

    if (hasVtexPlans) {
      initVtexPlansCalculator(root);
      return;
    }

    const isShopifyOnly = mode === 'shopify-only';
    const form = root.querySelector('.cost-calc-form');
    const compare = root.querySelector('[data-cost-calc-compare]');
    const result = root.querySelector('[data-cost-calc-result]');
    const savingsEl = root.querySelector('[data-cost-calc-savings]');
    const noteEl = root.querySelector('[data-cost-calc-result-note]');
    const shopifyTotalEl = root.querySelector('[data-cost-calc-shopify-total]');
    const resultHeading = root.querySelector('.cost-calc-result__heading');
    const salesInput = root.querySelector('[data-cost-calc-monthly-sales]');

    if (!form || !result || !compare) return;

    let hasCalculated = false;

    root.querySelectorAll('[data-cost-calc-grouped-input]').forEach((input) => {
      bindGroupedInput(input);
      const initial = parseNum(input.value);
      if (initial > 0) {
        input.value = formatGroupedNumber(initial);
      }
    });

    function renderEstimateResult(comparison) {
      if (shopifyTotalEl) shopifyTotalEl.textContent = formatCostCell(comparison.shopifyTotal);

      const annualLabel = formatAmount(comparison.annualSales);
      const monthlyLabel = formatAmount(comparison.shopifyMonthlyTotal);
      savingsEl.textContent = formatCostCell(comparison.shopifyTotal);
      result.classList.remove('cost-calc-result--favorable', 'cost-calc-result--unfavorable');
      noteEl.textContent = `Con ventas mensuales de ${formatAmount(comparison.monthlySales)} (${annualLabel}/año), el costo estimado con Shopify Plus sería ${formatCostCell(comparison.shopifyTotal)}/año (~${monthlyLabel}/mes).`;

      result.hidden = false;
    }

    function renderComparisonResult(comparison) {
      setVtexTotal(root, comparison.vtexTotal / 12, comparison.vtexTotal);
      if (shopifyTotalEl) shopifyTotalEl.textContent = formatCostCell(comparison.shopifyTotal);

      const annualLabel = formatAmount(comparison.annualSales);
      savingsEl.textContent = formatSavingsDisplay(comparison.savings);
      result.classList.toggle('cost-calc-result--favorable', comparison.savings > 0);
      result.classList.toggle('cost-calc-result--unfavorable', comparison.savings < 0);

      if (comparison.savings > 0) {
        noteEl.textContent = `Con ventas mensuales de ${formatAmount(comparison.monthlySales)} (${annualLabel}/año), migrar a Shopify Plus podría ahorrarte este monto frente a VTEX Business.`;
      } else if (comparison.savings < 0) {
        noteEl.textContent = `Con ventas mensuales de ${formatAmount(comparison.monthlySales)} (${annualLabel}/año), Shopify Plus sería ~${formatCostCell(Math.abs(comparison.savings))} más costoso al año con estas tarifas.`;
      } else {
        noteEl.textContent = `Con ventas mensuales de ${formatAmount(comparison.monthlySales)} (${annualLabel}/año), el costo estimado es equivalente con estas tarifas.`;
      }

      result.hidden = false;
    }

    function renderResult(comparison) {
      if (isShopifyOnly) {
        renderEstimateResult(comparison);
        return;
      }

      renderComparisonResult(comparison);
    }

    function calculate({ focusResult = false, formatSalesOnSuccess = false } = {}) {
      const monthlySales = readInput(root, '[data-cost-calc-monthly-sales]');

      if (monthlySales <= 0) {
        if (salesInput) {
          salesInput.setAttribute('aria-invalid', 'true');
          if (!hasCalculated) salesInput.focus();
        }
        return false;
      }

      if (salesInput) {
        salesInput.setAttribute('aria-invalid', 'false');
        if (formatSalesOnSuccess) {
          salesInput.value = formatGroupedNumber(monthlySales);
        }
      }

      const comparison = isShopifyOnly
        ? buildShopifyOnly(root, monthlySales)
        : buildComparison(root, monthlySales);
      renderResult(comparison);

      const firstReveal = compare.hidden;
      compare.hidden = false;
      hasCalculated = true;

      if (firstReveal && focusResult) {
        requestAnimationFrame(() => {
          if (resultHeading) {
            resultHeading.focus();
            resultHeading.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }

      return true;
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      calculate({ focusResult: true, formatSalesOnSuccess: true });
    });

    const liveInputSelector = isShopifyOnly
      ? '[data-cost-calc-monthly-sales]'
      : '[data-cost-calc-monthly-sales], [data-cost-calc-monthly-fixed], [data-cost-calc-fee-b2c], [data-cost-calc-voucher]';
    const liveInputs = root.querySelectorAll(liveInputSelector);

    liveInputs.forEach((input) => {
      input.addEventListener('input', () => {
        if (!hasCalculated) return;
        calculate();
      });
    });
  });
})();
